export const SWITCH_COMPANY_URL = "/auth/switchCompany";
export const LICENCE_KEY_URL =
  import.meta.env.APP_LIC_KEY_BASE_URL + "auth/getWebLicenceKey";
//export const GET_LICENCE_KEY = "/auth/getLicenceKey";
export const CHANGE_CURRENT_PASSWORD_URL = "/auth/updErpPassword";
